import Store from './Store'

function getSuppliersForProduct(product) {
    return new Store('products/' + product + '/suppliers');
}

export {getSuppliersForProduct};